import React from "react";
import { Link } from "react-router-dom";
import MarketingLayout from "./components/MarketingLayout.js";

export default function Download() {
  return (
    <MarketingLayout>
      <div className="marketing-page-content download-page">
        <header className="marketing-page-intro">
          <p className="marketing-page-eyebrow">Product</p>
          <h1>Use Zolaid in your browser</h1>
          <p className="page-lead">
            Zolaid is a website. People use it in the browser — open the homepage or start a chat.
          </p>
        </header>

        <section
          className="marketing-section-card download-web download-web--primary"
          aria-labelledby="open-zolaid-heading"
        >
          <span className="marketing-kicker" aria-hidden>
            Web
          </span>
          <h2 id="open-zolaid-heading" className="marketing-section-title">
            Open Zolaid
          </h2>
          <p className="marketing-section-text">
            Go to zolaid.com in Chrome, Safari, Firefox, or Edge. A current browser and an internet connection are enough.
          </p>
          <div className="marketing-cta-row download-web-ctas">
            <Link to="/" className="marketing-cta">
              Open the site
            </Link>
            <Link to="/chatbot" className="marketing-cta marketing-cta--secondary">
              Start a chat
            </Link>
          </div>
        </section>
      </div>
    </MarketingLayout>
  );
}
